import { useMemo } from 'react'
import { isPending, usePromise } from 'react-sync-promise'

import type { CybusLogSource } from '../../../domain'

import { useAppUsecase } from '../State'

/** `null` while it isn't known yet */
export const useAreLogsAvailable = (type: CybusLogSource, id: string): boolean | null => {
    const containerLogsUsecase = useAppUsecase('containerLogsUsecase')

    const logs = usePromise<boolean, never>(useMemo(() => containerLogsUsecase.areLogsAvailable(type, id), [containerLogsUsecase, id, type]))

    return isPending(logs) ? null : logs.value
}
